module.exports = __webpack_public_path__ + "img/sausageAndEggs.3f263693.png";